import Header from '../components/common/Header';
import CoordinatorFooter from '../components/common/CoordinatorFooter';
import { Outlet } from 'react-router-dom';
import {isCoordinator} from "../utils/authUtils";
import Footer from "../components/common/Footer";

const DefaultLayout = () => {
  return (
    <>
      <Header />
      <Outlet />
        {isCoordinator() ? <CoordinatorFooter /> : <Footer />}
    </>
  );
};

export default DefaultLayout;
